import type { Line } from "./base";

const TABLE_TAG = Symbol("tableLine");
type TableTaggedLine = Line & { [TABLE_TAG]?: true };

function toTaggedLine(line: Line): TableTaggedLine {
  return line as TableTaggedLine;
}

export function markTableLine(line: Line): Line {
  toTaggedLine(line)[TABLE_TAG] = true;
  return line;
}

export function isTableLine(line: Line): boolean {
  return toTaggedLine(line)[TABLE_TAG] === true;
}

export function preserveTableTag(source: Line, target: Line): void {
  if (toTaggedLine(source)[TABLE_TAG]) toTaggedLine(target)[TABLE_TAG] = true;
}
